<template lang="pug">
  .container-settle.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/settle") 结算账户管理
          el-breadcrumb-item 结算账户详情
    template(v-if="settle_type === 1")
      cBox
        c-header-small
          template(slot="left") 账户信息
        el-form(:model="accountDetail",label-position="right",label-width="150px")
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="结算账户类型") {{ settle_type | settle_type_short }}
              el-form-item(label="开户银行") {{ accountDetail.deposit_bank }}
              el-form-item(label="创建时间") {{ accountDetail.deposit_bank }}
            el-col(:span="12")
              el-form-item(label="开户名") {{ accountDetail.deposit_name }}
              el-form-item(label="银行卡号") {{ accountDetail.bank_account }}
              el-form-item(label="状态") {{ accountDetail.status | acccountStatus }}
      hr
      cBox
        c-header-small
          template(slot="left") 绑定收款账户
        el-table(:data="accountList.list", fit, v-loading="accountList.listLoading", :element-loading-fullscreen="false")
          el-table-column(property="account_id", label="账户 ID", min-width="200", show-tooltip-when-overflow)
          el-table-column(property="desc", label="账户名称", min-width="200", show-tooltip-when-overflow)
          el-table-column(property="binding_create_time", label="绑定时间", min-width="200", show-tooltip-when-overflow)
        .container-pagination
          el-pagination(layout="sizes, prev, pager, next, total",
            :current-page="accountList.page", :total="accountList.total", :page-size="accountList.size",
            :page-sizes="[5, 10, 15, 20, 25, 50]", @size-change="changeAccountListSize", @current-change="getAccountList")

    cBox(v-else-if="settle_type === 3 && mch_type === 2", v-loading="loading")
      qriously(:value="wallet_url", :size="240", :padding="20" v-if="wallet_url").align-center
      .align-center.bold 扫描二维码以访问您的富力钱包

    template(v-else-if="settle_type === 3 && mch_type === 1")
      cBox(v-loading="loading", :element-loading-fullscreen="false")
        el-form(:model="walletInfo",label-position="right",label-width="150px")
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="结算账户类型") 富力钱包
              el-form-item(label="添加时间") {{ walletInfo.wallet.create_time }}
            el-col(:span="12")
              el-form-item(label="账户状态") {{ walletInfo.bank_card_count === 0 ? '未绑定' : '已绑定' }}
              el-form-item(label="钱包 ID") {{ walletInfo.wallet.id }}
      hr
      cBox
        c-header-small
          template(slot="left") 绑定的银行卡
          template(slot="right") 
            el-button(type="primary", @click="showCreateCard") 更换绑定银行卡
        el-table(:data="bankCardList.list", fit, v-loading="bankCardList.listLoading", :element-loading-fullscreen="false")
          el-table-column(property="deposit_name", label="开户名", min-width="150", show-tooltip-when-overflow)
          el-table-column(property="deposit_bank", label="开户银行", min-width="150", show-tooltip-when-overflow)
          el-table-column(property="wallet_id", label="钱包 ID", min-width="200", show-tooltip-when-overflow)
        //- .container-pagination
          el-pagination(layout="sizes, prev, pager, next, total",
            :current-page="bankCardList.page", :total="bankCardList.total", :page-size="bankCardList.size",
            :page-sizes="[5, 10, 15, 20, 25, 50]", @size-change="changeBankCardListSize", @current-change="getBankCardList")
      cBox
        c-header-small
          template(slot="left") 流水列表
        el-form(:model="bankLogList",label-position="right",label-width="100px")
          el-row(:gutter="10")
            el-col(:span="12")
              el-form-item(label="时间范围")
                el-date-picker(v-model="bankLogList.time", type="datetimerange", placeholder="选择时间范围")
            el-col(:span="12")
              el-form-item(label="")
                el-button(@click="setFilter",type="primary") 搜索
                el-button(@click="clearFilter", v-show="bankLogList.hasFilter") 清除
        el-table(:data="bankLogList.list", fit, v-loading="bankLogList.listLoading", :element-loading-fullscreen="false")
          el-table-column(property="create_time", label="时间", min-width="175", show-tooltip-when-overflow)
          el-table-column(property="elec_cheque_no", label="明细单号", min-width="250", show-tooltip-when-overflow)
          el-table-column(label="交易类型", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.type | bankLogType }}
          el-table-column(label="金额", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.amount | toYuan }}
        .container-pagination
          el-pagination(layout="sizes, prev, pager, next, total",
            :current-page="bankLogList.page", :total="bankLogList.total", :page-size="bankLogList.size",
            :page-sizes="[5, 10, 15, 20, 25, 50]", @size-change="changeBankLogListSize", @current-change="getBankLogList")
      
      el-dialog(title="绑定银行卡", :visible.sync="createCard.show")
        el-form(:model="createCard", label-position="right", label-width="125px")
          el-form-item(label="开户名") {{ createCard.mch_name }}
          el-form-item(label="开户银行", required)
            el-select(v-model="createCard.class_code", @change="setBankClass")
              el-option(:value="null", label="未选择") 
              el-option(v-for="b in createCard.bankClassList", :key="b.class_code", :value="b.class_code", :label="b.class_name")
          el-form-item(label="区域", required)
            el-select(v-model="createCard.area_code", @change="setBankArea")
              el-option(:value="null", label="未选择")
              el-option(v-for="b in createCard.bankAreaList", :key="b.area_code", :value="b.area_code", :label="b.province_name + b.city_name")
          el-form-item(label="支行", required)
            el-select(v-model="createCard.source.bank_code")
              el-option(:value="null", label="未选择")
              el-option(v-for="b in createCard.bankList", :key="b.bank_code", :value="b.bank_code", :label="b.bank_name")
          el-form-item(label="对公账户账号", required)
            el-input(v-model="createCard.source.bank_account")
        .dialog-footer(slot="footer")
          el-button(type="primary", @click="saveCreateCard()") 保存
          el-button(@click="hideCreateCard()") 取消
</template>

<script>
export default {
  data() {
    return {
      accountDetail: {},
      accountList: {
        page: 1,
        size: 5,
        status: 0,
        list: [],
        total: 0,

        listLoading: false
      },

      walletInfo: {
        wallet: {}
      },
      bankCardList: {
        page: 1,
        size: 5,
        status: 0,
        list: [],
        total: 0,

        listLoading: false
      },
      createCard: {
        show: false,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      },
      bankLogList: {
        page: 1,
        size: 5,
        status: 0,
        list: [],
        total: 0,

        listLoading: false,
        time: [],
        hasFilter: false
      },

      wallet_url: null,
      loading: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    mch_type() {
      return this.$store.getters.userInfo.mch_type;
    },
    settle_type() {
      return parseInt(this.$route.params.settle_type);
    },
    settle_account() {
      return this.$route.params.settle_account_id;
    },
    settle_rela_id() {
      return this.$route.params.settle_rela_id;
    }
  },
  filters: {
    bankLogType(source) {
      switch (source) {
        case 1:
          return "直接转账";
        case 2:
          return "收入";
        case 3:
          return "支出";
        default:
          return source;
      }
    }
  },
  methods: {
    showCreateCard() {
      this.createCard = {
        show: true,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      };

      this.getBankClassList().then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.createCard.class_code = data[0].class_code;
          this.setBankClass();
        }
      });
      this.getMchDetail();
    },
    hideCreateCard() {
      this.createCard = {
        show: false,
        source: {
          bank_account: null,
          bank_code: null
        },
        mch_name: null,
        class_code: null,
        area_code: null,
        bankClassList: [],
        bankAreaList: [],
        bankList: []
      };
    },
    saveCreateCard() {
      if (!this.createCard.source.bank_account) {
        this.$message({
          type: "warning",
          message: `请输入对公账户账号。`
        });
      }
      if (!this.createCard.source.bank_code) {
        this.$message({
          type: "warning",
          message: `请选择开户支行。`
        });
      }

      this.$store
        .dispatch("CHANGE_ACCOUNT_BINDING_CARD", this.createCard.source)
        .then(() => {
          this.hideCreateCard();
          this.getWalletInfo();
          this.getBankCardList(1);

          this.$message({
            type: "success",
            message: "银行卡绑定成功。"
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `银行卡绑定失败。${code}：${msg}`
          });
        });
    },

    setBankClass() {
      this.getBankAreaList().then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.createCard.area_code = data[0].area_code;
          this.setBankArea();
        } else {
          this.createCard.area_code = null;
        }
      });
    },
    setBankArea() {
      this.getBankList().then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.createCard.source.bank_code = data[0].bank_code;
        } else {
          this.createCard.source.bank_code = null;
        }
      });
    },

    getBankClassList() {
      return this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then(data => {
          this.createCard.bankClassList = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`
          });
        });
    },
    getBankAreaList() {
      return this.$store
        .dispatch("GET_BANK_AREA_LIST", this.createCard.class_code)
        .then(data => {
          this.createCard.bankAreaList = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行地区列表失败。${code}：${msg}`
          });
        });
    },
    getBankList() {
      const params = {
        class_code: this.createCard.class_code,
        area_code: this.createCard.area_code
      };
      return this.$store
        .dispatch("GET_BANK_LIST", params)
        .then(data => {
          this.createCard.bankList = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$toast({
            message: `获取支行列表失败。${code}：${msg}`,
            duration: 3000
          });
        });
    },
    getMchDetail() {
      this.loading = true;
      const { uname } = this.userInfo;
      return this.$store
        .dispatch("GET_MCH_DETAIL", uname)
        .then(data => {
          this.createCard.mch_name = data.mch_name;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$alert(`商家资料获取失败。${code}：${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getWalletURL() {
      this.loading = true;

      return this.$store
        .dispatch("GET_WALLET_URL")
        .then(({ wallet_base_url }) => {
          this.wallet_url = wallet_base_url;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取富力钱包资料失败。${code}：${msg}`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getWalletInfo() {
      this.loading = true;

      return this.$store
        .dispatch("GET_WALLET_INFO")
        .then(data => {
          this.walletInfo = Object.assign({}, data, {
            wallet: data.wallet,
            person_info:
              typeof data.person_info === "object"
                ? Object.assign({}, data.person_info)
                : {},
            user_info:
              typeof data.user_info === "object"
                ? Object.assign({}, data.user_info)
                : {}
          });
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取富力钱包页面地址失败。${code}：${msg}`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getAccountDetail() {
      return this.$store
        .dispatch("GET_SETTLE_ACCOUNT_DETAIL", this.settle_account)
        .then(data => {
          if (this.settle_type === 1) {
            this.getAccountList(1);
          }
          this.accountDetail = data;
          return data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取账户信息失败。${code}：${msg}`
          });
        });
    },

    refresh() {
      if (this.settle_type === 1) {
        this.getAccountList(this.accountList.page);
      } else if (this.settle_type === 3 && this.mch_type === 1) {
        this.getBankCardList(this.bankCardList.page);
        this.getBankLogList(this.bankCardList.page);
      }
    },
    changeAccountListSize(size = 10) {
      this.accountList.size = size;
      this.getAccountList(1);
    },
    getAccountList(page = 1) {
      if (!this.accountList.listLoading) {
        this.accountList.page = page;
        this.accountList.listLoading = true;
      } else {
        return;
      }
      const settle_rela_id = this.settle_account;

      this.$store
        .dispatch("GET_SETTLE_ACCOUNT_BINDING_LIST", {
          settle_rela_id,
          offset: this.accountList.size * (this.accountList.page - 1),
          limit: this.accountList.size,
          stat: true
        })
        .then(data => {
          this.accountList.list = data.list;
          this.accountList.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.accountList.listLoading = false;
        });
    },

    changeBankCardListSize(size = 10) {
      this.bankCardList.size = size;
      this.getBankCardList(1);
    },
    getBankCardList(page = 1) {
      if (!this.bankCardList.listLoading) {
        this.bankCardList.page = page;
        this.bankCardList.listLoading = true;
      } else {
        return;
      }
      const settle_account = this.settle_account;

      this.$store
        .dispatch("GET_BANK_CARD_LIST", {
          settle_account,
          offset: this.bankCardList.size * (this.bankCardList.page - 1),
          limit: this.bankCardList.size,
          stat: true
        })
        .then(data => {
          this.bankCardList.list = data;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.bankCardList.listLoading = false;
        });
    },

    setFilter() {
      if (
        Array.isArray(this.bankLogList.time) &&
        this.bankLogList.time.length === 2
      ) {
        this.bankLogList.hasFilter = true;
      } else {
        this.bankLogList.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter() {
      this.bankLogList.hasFilter = false;
      this.bankLogList.time = [];
      this.getBankLogList(1);
    },
    changeBankLogListSize(size = 10) {
      this.bankLogList.size = size;
      this.getBankLogList(1);
    },
    getBankLogList(page = 1) {
      if (!this.bankLogList.listLoading) {
        this.bankLogList.page = page;
        this.bankLogList.listLoading = true;
      } else {
        return;
      }
      const _filters = Object.assign(
        {},
        {
          start_time:
            Array.isArray(this.bankLogList.time) &&
            typeof this.bankLogList.time[0] !== "undefined"
              ? this.$datetimeFormatter(this.bankLogList.time[0])
              : null,
          end_time:
            Array.isArray(this.bankLogList.time) &&
            typeof this.bankLogList.time[1] !== "undefined"
              ? this.$datetimeFormatter(this.bankLogList.time[1])
              : null
        }
      );

      this.$store
        .dispatch(
          "GET_WALLET_LOG_LIST",
          Object.assign(
            {},
            {
              offset: this.bankLogList.size * (this.bankLogList.page - 1),
              limit: this.bankLogList.size,
              stat: true
            },
            _filters
          )
        )
        .then(data => {
          this.bankLogList.list = data.list;
          this.bankLogList.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.bankLogList.listLoading = false;
        });
    }
  },
  mounted() {
    if (this.settle_type === 1) {
      this.getAccountDetail();
    } else if (this.mch_type === 2) {
      this.getWalletURL();
    } else {
      this.getWalletInfo();
      this.getBankCardList();
      this.getBankLogList();
    }
  }
};
</script>
